import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import AddressAutoCompleteInput from 'components/AddressAutoCompleteInput';

import HeroSecondaryCta from 'bento-ordering/base/components/HeroSecondaryCta';
import { scrollTo } from 'bento-ordering/base/utils/domHelpers';

const LocationListHeroContent = ({
  heading,
  handleSelect,
  address,
  showAddressAutoComplete,
  isLocationListSortingEnabled,
  hasHeroImage
}) => {
  const secondaryCtaText = showAddressAutoComplete
    ? 'Or browse locations below'
    : 'Browse locations below';

  return (
    <Box width="100%">
      {heading}
      {isLocationListSortingEnabled && (
        <>
          {showAddressAutoComplete && (
            <Box
              minHeight="53px"
              mt={2}
              ml="auto"
              mr="auto"
              maxWidth={'430px'}
              pr={{ xs: 3, md: 0 }}
              pl={{ xs: 3, md: 0 }}
            >
              <AddressAutoCompleteInput
                label="Start with your address"
                includeAdornment
                handleSelect={handleSelect}
                isOnDarkBackground
                initialValue={address}
              />
            </Box>
          )}
          <Box mt={1.5}>
            <HeroSecondaryCta
              handleClick={() =>
                scrollTo(document.getElementById('locations-list-container'))
              }
              label={secondaryCtaText}
              hasHeroImage={hasHeroImage}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

LocationListHeroContent.propTypes = {
  heading: PropTypes.node.isRequired,
  handleSelect: PropTypes.func.isRequired,
  address: PropTypes.string,
  showAddressAutoComplete: PropTypes.bool,
  isLocationListSortingEnabled: PropTypes.bool,
  hasHeroImage: PropTypes.bool
};

LocationListHeroContent.defaultProps = {
  address: '',
  showAddressAutoComplete: true
};

export default LocationListHeroContent;
